export enum ActivityOrigin {
  Manual = 0,
  Copilot = 1,
  Autonomous = 2
}

export interface ActivityListResponse {
  response: string;
  list: ActivityListResponse.Item[];
  itemCount: number;
  page: number;
  pageSize: number;
  oldusers: ActivityListResponse.Additional[];
}

export namespace ActivityListResponse {
  export interface Item {
    additionals: Additional[];
    HasMoreContent: boolean;
    files: File[];
    culture: string;
    LogId: number;
    Count: number;
    ID: number;
    Entity: number;
    Type?: number;
    Inbound?: boolean;
    date: string;
    date2: string;
    activityCreated: string;
    Html?: boolean;
    ActivityTypeID?: number;
    ActionID?: number;
    ActionName?: string;
    noDueAmount: number;
    UserID?: number;
    Username: string;
    UserEmail: string;
    Creator?: number;
    CreatorUsername: string;
    From?: string;
    FromName?: string;
    To?: string;
    cc?: string;
    bcc?: string;
    Subject?: string;
    Content: string;
    TaskDueDate?: string;
    secureContent: string;
    hasTags: boolean;
    hasIOs: boolean;
    hasAttachments?: boolean;
    hasattachments: string;
    personName: string;
    smsphone?: string;
    ResponsibleUsername: string;
    isDone: boolean;
    HasBounceData?: boolean;
    Tags?: Tag[];
    tagList: string;
    Status?: number;
    Failed: boolean;
    IOCount: number;
    Amount: number;
    OverDueAmount: number;
    ValidatorUserID?: number;
    hasComments: boolean;
    formattedContent: string;
    ClearContent: string;
    customerSite: string;
    followUpMail: string;
    clearPhone: string;
    PersonId: number;
    Name: string;
    Contact: string;
    Phone: string;
    Address: string;
    Created: string;
    CreatorUserID: number;
    Comments: string;
    Token: string;
    CalculatedAmount: number;
    CalculatedOverdueAmount: number;
    CalculatedCount: number;
    CalculatedDate: string;
    typeName: "Email" | "SMS" | "Task" | "Comment" | "Whatsapp";
    typeNameWithIco:
      | "Email"
      | "SMS"
      | "Task"
      | "Comment"
      | "Whatsapp"
      | "(!) Email";
    groupName?: string;
    groupId?: string;
    Archived?: boolean;
    Read?: boolean;
    Chat?: boolean;
    ChatStatus?: number;
    Pinned?: boolean;
    Spam?: boolean;
    CollectorName?: string;
    LastActivityDate: string;
    Origin?: number;
  }

  export interface Additional {
    Id: string;
    Value: string;
  }
  export interface File {
    response: any;
    fileName: string;
    id: string;
    inline?: boolean;
  }
  export interface Tag {
    TagID: number;
    Name: string;
    Created: string;
    CreatorUserID: number;
    ImportID?: number;
    TagID_ref: any;
  }
}
